import React from "react";
import { motion } from "framer-motion";

const galleryImages = [
  {
    url: "https://images.unsplash.com/photo-1683889842937-bfd75dbc4a81?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxmaXRuZXNzJTIwbW9kZWwlMjBwb3J0cmFpdCUyMGd5bXxlbnwwfHx8fDE3NzU3NTMxMDl8MA&ixlib=rb-4.1.0&q=85",
    alt: "Fitness model at gym",
    span: "md:col-span-8 md:row-span-2",
  },
  {
    url: "https://images.unsplash.com/photo-1678875524808-78e1d24b6597?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxmaXRuZXNzJTIwbW9kZWwlMjBwb3J0cmFpdCUyMGd5bXxlbnwwfHx8fDE3NzU3NTMxMDl8MA&ixlib=rb-4.1.0&q=85",
    alt: "Holding blue plates",
    span: "md:col-span-4 md:row-span-1",
  },
  {
    url: "https://images.unsplash.com/photo-1758957646695-ec8bce3df462?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBneW0lMjB3b3Jrb3V0fGVufDB8fHx8MTc3NTc1MzEwOXww&ixlib=rb-4.1.0&q=85",
    alt: "Modern luxury gym",
    span: "md:col-span-4 md:row-span-1",
  },
  {
    url: "https://images.unsplash.com/photo-1549505415-e16dbd446231?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxmaXRuZXNzJTIwbW9kZWwlMjBwb3J0cmFpdCUyMGd5bXxlbnwwfHx8fDE3NzU3NTMxMDl8MA&ixlib=rb-4.1.0&q=85&w=600",
    alt: "Fitness portrait",
    span: "md:col-span-6 md:row-span-1",
  },
  {
    url: "https://images.unsplash.com/photo-1628935291759-bbaf33a66dc6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxmaXRuZXNzJTIwbW9kZWwlMjBwb3J0cmFpdCUyMGd5bXxlbnwwfHx8fDE3NzU3NTMxMDl8MA&ixlib=rb-4.1.0&q=85&w=600",
    alt: "Workout session",
    span: "md:col-span-6 md:row-span-1",
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { staggerChildren: 0.08 } },
};

const itemVariants = {
  hidden: { opacity: 0, scale: 0.95 },
  show: { opacity: 1, scale: 1, transition: { duration: 0.5, ease: "easeOut" } },
};

export default function Portfolio() {
  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#0A0A0A] relative"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="mb-16"
        >
          <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-bold text-[#FF3B30] mb-4">
            Content Showcase
          </p>
          <h2
            data-testid="portfolio-heading"
            className="font-['Barlow_Condensed'] text-4xl sm:text-5xl font-bold uppercase tracking-tight text-white"
          >
            Top Performing Content
          </h2>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          className="grid grid-cols-1 md:grid-cols-12 gap-4"
        >
          {galleryImages.map((img, i) => (
            <motion.div
              key={i}
              variants={itemVariants}
              data-testid={`portfolio-image-${i}`}
              className={`${img.span} relative overflow-hidden rounded-xl group cursor-pointer`}
            >
              <div className="relative w-full h-64 md:h-full min-h-[240px]">
                <img
                  src={img.url}
                  alt={img.alt}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-500" />
                <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-500">
                  <p className="text-sm font-bold text-white uppercase tracking-wider">
                    {img.alt}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
